// extracted by mini-css-extract-plugin
module.exports = {"root":"InfoRow_root__1Ep2J","left":"InfoRow_left__3iqhx"};